<div class="form-typography margin-bottom-large help-question" *ngIf="activeQuestion">
  <div class="grid">
    <div class="cell cell-small-col-span-6 cell-large-col-span-12">
      <h1 class="text-center text-left-small-only margin-bottom-small">{{ activeQuestion.label }}</h1>
      <div class="padding-xxbig flex flex-justify-center" *ngIf="userDataLoading">
        <mat-spinner diameter="50"></mat-spinner>
      </div>

      <div class="grid" *ngIf="!userDataLoading">
        <div class="cell cell-small-col-span-6" [ngClass]="{
          'cell-medium-col-start-1 cell-medium-col-span-8 cell-large-col-start-2 cell-large-col-span-10': activeQuestion.key === 'topic',
          'cell-large-col-start-3 cell-large-col-span-8': activeQuestion.settings.choices?.length === 4,
          'cell-large-col-span-12': activeQuestion.key !== 'topic' && activeQuestion.settings.choices?.length !== 4
        }">
          <open-tile-radio [question]="activeQuestion" [form]="form"></open-tile-radio>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Show this only when an option is pre-selected.
  This button provides an option to continue without changing pre-populated selection -->
<div class="text-center padding-horizontal-medium" *ngIf="activeQuestion.data !== ''">
  <button class="margin-bottom-large help-flow-action" mat-flat-button color="primary" (click)="goToNextStep()">Continue</button>
</div>
